// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Sentry = require("../../../reason/Sentry.bs.js");
let Callout = require("../../common/Components/Callout.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let HtmlHolder = require("../../../reason/common/HtmlHolder.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyLocationMap = require("../../common/Property/PropertyLocationMap.bs.js");
let PropertyPage__Files = require("../../propertyPage/PropertyPage__Files.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ClientPageMatchPopup = require("./components/ClientPageMatchPopup.bs.js");
let PropertyImageGallery = require("../../common/Components/PropertyImageGallery.bs.js");
let UpgradePlanWarningV5 = require("../../common/Components/UpgradePlanWarningV5.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ClientPageMatchCardAgent = require("./ClientPageMatchCardAgent.bs.js");
let ToggleMatchDismissButton = require("./ToggleMatchDismissButton.bs.js");
let ForSalePropertyAttributes = require("../../common/Property/ForSalePropertyAttributes.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let BuyerPageMatchAnonymousAgent = require("./BuyerPageMatchAnonymousAgent.bs.js");
let UseShouldShowPropertyDetails = require("../../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let ContactForSalePropertyAgentButton = require("./ContactForSalePropertyAgentButton.bs.js");
let BuyerPageMatchCardOwnAnonymousAgent = require("./BuyerPageMatchCardOwnAnonymousAgent.bs.js");
let QuietPropertyMatchPopupQuery_graphql = require("../../../__generated__/QuietPropertyMatchPopupQuery_graphql.bs.js");
let QuietPropertyMatchPopup_forSalePropertyV5_graphql = require("../../../__generated__/QuietPropertyMatchPopup_forSalePropertyV5_graphql.bs.js");
let QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql = require("../../../__generated__/QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.bs.js");
let QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql = require("../../../__generated__/QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.bs.js");
let QuietPropertyMatchPopup_statusCallout_soldProperty_graphql = require("../../../__generated__/QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.bs.js");
let QuietPropertyMatchPopup_description_forSalePropertyV5_graphql = require("../../../__generated__/QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.bs.js");
let QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql = require("../../../__generated__/QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.bs.js");
let QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql = require("../../../__generated__/QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.bs.js");
let QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql = require("../../../__generated__/QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.bs.js");

let convertFragment = QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function QuietPropertyMatchPopup$Description(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_description_forSalePropertyV5_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "description",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(HtmlHolder.make, {
          innerHtml: match.description
        }),
        className: "leading-[1.5] text-zinc-700"
      }),
      className: "flex flex-col gap-2 max-w-[75ch]"
    })
  });
}

let Description = {
  Fragment: Fragment,
  make: QuietPropertyMatchPopup$Description
};

let convertFragment$1 = QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

let Fragment_forSalePropertyAgentVisibilityReason_decode = QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.Utils.forSalePropertyAgentVisibilityReason_decode;

let Fragment_forSalePropertyAgentVisibilityReason_fromString = QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.Utils.forSalePropertyAgentVisibilityReason_fromString;

let Fragment$1 = {
  forSalePropertyAgentVisibilityReason_decode: Fragment_forSalePropertyAgentVisibilityReason_decode,
  forSalePropertyAgentVisibilityReason_fromString: Fragment_forSalePropertyAgentVisibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function QuietPropertyMatchPopup$Agent$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_Agent_forSalePropertyV5_graphql.node, convertFragment$1, props.property);
  let agent = match.agentV2;
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(match.fragmentRefs);
  if (!shouldShowPropertyDetails) {
    return JsxRuntime.jsx(UpgradePlanWarningV5.make, {
      children: "You need to be on the Pro Plan to connect with the listing agent."
    });
  }
  switch (agent.__typename) {
    case "AnonymousForSalePropertyAgent" :
      return JsxRuntime.jsx(BuyerPageMatchAnonymousAgent.make, {
        agent: agent.fragmentRefs
      });
    case "VisibleForSalePropertyAgent" :
      let agent$1 = agent.agent;
      let tmp = agent.visibilityRule;
      if (tmp === "OWN_ANONYMOUS") {
        return JsxRuntime.jsx(BuyerPageMatchCardOwnAnonymousAgent.make, {
          agent: agent$1.fragmentRefs
        });
      } else {
        return JsxRuntime.jsx(ClientPageMatchCardAgent.make, {
          agent: agent$1.fragmentRefs
        });
      }
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected for sale property agent ` + agent._0);
  }
}

let WithoutErrorBoundary = {
  make: QuietPropertyMatchPopup$Agent$WithoutErrorBoundary
};

function QuietPropertyMatchPopup$Agent(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property agent",
    children: JsxRuntime.jsx(QuietPropertyMatchPopup$Agent$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let Agent = {
  Fragment: Fragment$1,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: QuietPropertyMatchPopup$Agent
};

let convertFragment$2 = QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function QuietPropertyMatchPopup$StatusCallout$WithdrawnProperty(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_withdrawnProperty_graphql.node, convertFragment$2, props.withdrawnProperty);
  let statusChangeComment = match.statusChangeComment;
  let formatedDate = DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match.withdrawnAt)), "MM/dd/yyyy");
  return JsxRuntime.jsx(Callout.Info.make, {
    children: statusChangeComment !== undefined ? JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Comments:",
            className: "text-zinc-600 font-medium"
          }),
          JsxRuntime.jsx("div", {
            children: statusChangeComment,
            className: "text-zinc-700"
          })
        ],
        className: "flex gap-2"
      }) : null,
    title: `The property was withdrawn on ` + formatedDate
  });
}

let WithdrawnProperty = {
  Fragment: Fragment$2,
  make: QuietPropertyMatchPopup$StatusCallout$WithdrawnProperty
};

let convertFragment$3 = QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.node, convertFragment$3, fRef);
}

let Fragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function QuietPropertyMatchPopup$StatusCallout$UnderContractProperty(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_underContractProperty_graphql.node, convertFragment$3, props.underContractProperty);
  let statusChangeComment = match.statusChangeComment;
  let formatedDate = DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match.statusChangedAt)), "MM/dd/yyyy");
  return JsxRuntime.jsx(Callout.Info.make, {
    children: statusChangeComment !== undefined ? JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Comments:",
            className: "text-zinc-600 font-medium"
          }),
          JsxRuntime.jsx("div", {
            children: statusChangeComment,
            className: "text-zinc-700"
          })
        ],
        className: "flex gap-2"
      }) : null,
    title: `The property was marked as UNDER CONTRACT on ` + formatedDate
  });
}

let UnderContractProperty = {
  Fragment: Fragment$3,
  make: QuietPropertyMatchPopup$StatusCallout$UnderContractProperty
};

let convertFragment$4 = QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.node, convertFragment$4, fRef);
}

let Fragment$4 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function QuietPropertyMatchPopup$StatusCallout$SoldProperty(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_soldProperty_graphql.node, convertFragment$4, props.soldProperty);
  let statusChangeComment = match.statusChangeComment;
  let formatedDate = DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match.statusChangedAt)), "MM/dd/yyyy");
  return JsxRuntime.jsx(Callout.Info.make, {
    children: statusChangeComment !== undefined ? JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Comments:",
            className: "text-zinc-600 font-medium"
          }),
          JsxRuntime.jsx("div", {
            children: statusChangeComment,
            className: "text-zinc-700"
          })
        ],
        className: "flex gap-2"
      }) : null,
    title: `The property was marked as SOLD on ` + formatedDate
  });
}

let SoldProperty = {
  Fragment: Fragment$4,
  make: QuietPropertyMatchPopup$StatusCallout$SoldProperty
};

let convertFragment$5 = QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.node, convertFragment$5, fRef);
}

let Fragment$5 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function QuietPropertyMatchPopup$StatusCallout(props) {
  let match = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_statusCallout_forSalePropertyV5_graphql.node, convertFragment$5, props.property);
  let status = match.status;
  let tmp;
  switch (status.__typename) {
    case "SoldProperty" :
      tmp = JsxRuntime.jsx(QuietPropertyMatchPopup$StatusCallout$SoldProperty, {
        soldProperty: status.fragmentRefs
      });
      break;
    case "UnderContractProperty" :
      tmp = JsxRuntime.jsx(QuietPropertyMatchPopup$StatusCallout$UnderContractProperty, {
        underContractProperty: status.fragmentRefs
      });
      break;
    case "WithdrawnProperty" :
      tmp = JsxRuntime.jsx(QuietPropertyMatchPopup$StatusCallout$WithdrawnProperty, {
        withdrawnProperty: status.fragmentRefs
      });
      break;
    case "__unselected" :
      tmp = null;
      break;
  }
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: tmp
  });
}

let StatusCallout = {
  WithdrawnProperty: WithdrawnProperty,
  UnderContractProperty: UnderContractProperty,
  SoldProperty: SoldProperty,
  Fragment: Fragment$5,
  make: QuietPropertyMatchPopup$StatusCallout
};

let convertFragment$6 = QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.node, convertFragment$6, fRef);
}

let MatchFragment_matchStateV5_decode = QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.Utils.matchStateV5_decode;

let MatchFragment_matchStateV5_fromString = QuietPropertyMatchPopup_matchForBuyerNeedV5_graphql.Utils.matchStateV5_fromString;

let MatchFragment = {
  matchStateV5_decode: MatchFragment_matchStateV5_decode,
  matchStateV5_fromString: MatchFragment_matchStateV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

let convertFragment$7 = QuietPropertyMatchPopup_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$7(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, QuietPropertyMatchPopup_forSalePropertyV5_graphql.node, convertFragment$7, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_forSalePropertyV5_graphql.node, convertFragment$7, fRef);
}

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, QuietPropertyMatchPopup_forSalePropertyV5_graphql.node, convertFragment$7);
}

function readResolverFragment$7(fRef) {
  return RescriptRelay_Fragment.read(QuietPropertyMatchPopup_forSalePropertyV5_graphql.node, convertFragment$7, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$7,
  waitForFragmentData: waitForFragmentData$7,
  use: use$7,
  useOpt: useOpt$7,
  readResolverFragment: readResolverFragment$7
};

function QuietPropertyMatchPopup$Divider(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "Base";
  let sizeClasses;
  sizeClasses = size === "Base" ? "my-6" : "my-10";
  return JsxRuntime.jsx("div", {
    className: TailwindMerge.twMerge([
      "border-t border-gray-200",
      sizeClasses
    ])
  });
}

let Divider = {
  make: QuietPropertyMatchPopup$Divider
};

function QuietPropertyMatchPopup$WithoutErrorBoundary(props) {
  let match = useOpt$6(props.match);
  let match$1 = RescriptRelay_Fragment.useFragment(QuietPropertyMatchPopup_forSalePropertyV5_graphql.node, convertFragment$7, props.property);
  let propertyRef = match$1.fragmentRefs;
  let propertyLocation = match$1.propertyLocation;
  let imageCount = match$1.imageCount;
  let fileCount = match$1.fileCount;
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(propertyRef);
  let title;
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
    case "PropertyLocationWithVisibleAddress" :
      title = `Property at ` + propertyLocation.locationDisplay;
      break;
    case "__unselected" :
      title = UnselectedUnionMemberError.raise(`Unselected property location ` + propertyLocation._0);
      break;
  }
  return JsxRuntime.jsx(ClientPageMatchPopup.make, {
    isOpen: props.isOpen,
    actions: JsxRuntime.jsxs("div", {
      children: [
        match !== undefined ? JsxRuntime.jsx(ToggleMatchDismissButton.make, {
            match: match.fragmentRefs
          }) : null,
        JsxRuntime.jsx(ContactForSalePropertyAgentButton.make, {
          property: propertyRef,
          position: "top"
        })
      ],
      className: "flex flex-row gap-2"
    }),
    title: title,
    onDismiss: props.onDismiss,
    targetType: "property",
    children: JsxRuntime.jsxs("div", {
      children: [
        imageCount !== undefined && imageCount.totalCount > 0 ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(PropertyImageGallery.make, {
              property: propertyRef
            })
          }) : null,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(PropertyPrice.make, {
              property: propertyRef,
              size: "medium"
            }),
            JsxRuntime.jsx(ForSalePropertyAttributes.make, {
              property: propertyRef,
              displayPropertyType: false
            })
          ],
          className: "flex flex-col gap-4 mt-4"
        }),
        JsxRuntime.jsx(QuietPropertyMatchPopup$Divider, {}),
        JsxRuntime.jsx(QuietPropertyMatchPopup$StatusCallout, {
          property: propertyRef
        }),
        JsxRuntime.jsx(QuietPropertyMatchPopup$Description, {
          property: propertyRef
        }),
        JsxRuntime.jsx(QuietPropertyMatchPopup$Divider, {}),
        fileCount !== undefined && fileCount.totalCount > 0 ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: "Files",
                className: "text-lg font-medium text-zinc-700"
              }),
              JsxRuntime.jsx(PropertyPage__Files.make, {
                property: propertyRef,
                showTitle: false
              })
            ],
            className: "flex flex-col gap-4"
          }) : null,
        ReactRender.ifTrue(JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: "Location",
                  className: "text-lg font-medium text-zinc-700"
                }),
                JsxRuntime.jsx(PropertyLocationMap.make, {
                  property: propertyRef,
                  size: "medium"
                })
              ],
              className: "flex flex-col gap-4"
            }),
            JsxRuntime.jsx(QuietPropertyMatchPopup$Divider, {})
          ]
        }), shouldShowPropertyDetails),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Listing agent",
              className: "text-lg font-medium text-zinc-700"
            }),
            JsxRuntime.jsx(QuietPropertyMatchPopup$Agent, {
              property: propertyRef
            })
          ],
          className: "flex flex-col gap-4"
        })
      ],
      className: "p-6 flex flex-col"
    })
  });
}

let WithoutErrorBoundary$1 = {
  make: QuietPropertyMatchPopup$WithoutErrorBoundary
};

function QuietPropertyMatchPopup$Page(props) {
  let onDismiss = props.onDismiss;
  let isOpen = props.isOpen;
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(DialogV5.make, {
      isOpen: isOpen,
      ariaLabel: "error",
      onDismiss: onDismiss,
      children: JsxRuntime.jsx(FragmentErrorBoundary.ErrorState.make, {
        fragmentDisplayName: "property details"
      })
    }),
    children: JsxRuntime.jsx(QuietPropertyMatchPopup$WithoutErrorBoundary, {
      isOpen: isOpen,
      match: props.match,
      property: props.property,
      onDismiss: onDismiss
    }),
    onError: error => Sentry.captureException(error, "QuietPropertyMatchPopup.res", undefined, undefined, undefined)
  });
}

let Page = {
  make: QuietPropertyMatchPopup$Page
};

let convertVariables = QuietPropertyMatchPopupQuery_graphql.Internal.convertVariables;

let convertResponse = QuietPropertyMatchPopupQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = QuietPropertyMatchPopupQuery_graphql.Internal.convertWrapRawResponse;

let use$8 = RescriptRelay_Query.useQuery(convertVariables, QuietPropertyMatchPopupQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, QuietPropertyMatchPopupQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(QuietPropertyMatchPopupQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(QuietPropertyMatchPopupQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(QuietPropertyMatchPopupQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(QuietPropertyMatchPopupQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$8,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function QuietPropertyMatchPopup$FromQueryLoader(props) {
  let query = usePreloaded(props.queryRef);
  let match = query.node;
  if (match !== undefined && match.__typename === "ForSalePropertyV5") {
    return JsxRuntime.jsx(QuietPropertyMatchPopup$Page, {
      isOpen: props.isOpen,
      match: props.match,
      property: match.fragmentRefs,
      onDismiss: props.onDismiss
    });
  } else {
    return null;
  }
}

let FromQueryLoader = {
  Query: Query,
  make: QuietPropertyMatchPopup$FromQueryLoader
};

function QuietPropertyMatchPopup$FromDetailsButton(props) {
  let propertyNodeId = props.propertyNodeId;
  let match = React.useState(() => false);
  let setIsShowingQuietMatchPopup = match[1];
  let match$1 = useLoader();
  let dispose = match$1[2];
  let loadQuery = match$1[1];
  let queryRef = match$1[0];
  let showQuietMatchPopup = () => {
    loadQuery({
      id: propertyNodeId
    }, undefined, undefined);
    setIsShowingQuietMatchPopup(param => true);
  };
  let hideQuietMatchPopup = () => setIsShowingQuietMatchPopup(param => false);
  React.useEffect(() => (() => dispose()), [dispose]);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      queryRef !== undefined ? JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(QuietPropertyMatchPopup$FromQueryLoader, {
            queryRef: Primitive_option.valFromOption(queryRef),
            isOpen: match[0],
            match: props.match,
            onDismiss: hideQuietMatchPopup
          }),
          fallback: null
        }) : null,
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => showQuietMatchPopup(),
        onMouseEnter: _e => {
          if (queryRef !== undefined) {
            return;
          } else {
            return loadQuery({
              id: propertyNodeId
            }, undefined, undefined);
          }
        },
        size: "small",
        icon: "view-details",
        children: "View details"
      })
    ]
  });
}

let FromDetailsButton = {
  make: QuietPropertyMatchPopup$FromDetailsButton
};

let make = QuietPropertyMatchPopup$Page;

exports.Description = Description;
exports.Agent = Agent;
exports.StatusCallout = StatusCallout;
exports.MatchFragment = MatchFragment;
exports.PropertyFragment = PropertyFragment;
exports.Divider = Divider;
exports.WithoutErrorBoundary = WithoutErrorBoundary$1;
exports.Page = Page;
exports.make = make;
exports.FromQueryLoader = FromQueryLoader;
exports.FromDetailsButton = FromDetailsButton;
/* use Not a pure module */
